import { MenuId } from 'moduleBase/modules/menu/types/MenuId';
import { MENU_MAIN_LOAD_CHANNELS_URL, MENU_MAIN_LOAD_DYNAMIC_SUB_MENU_COMPLETE, MENU_MAIN_LOAD_PROJECTS_URL, MENU_MAIN_LOAD_SUB_MENU_COMPLETE } from 'moduleBase/modules/menu/constants';
import { ApiError } from '@collaborator/npm_modules/dist/modules/base/errors/ApiError';

var menuMainLoadDynamicSubMenuComplete = function menuMainLoadDynamicSubMenuComplete(id, items) {
  return {
    type: MENU_MAIN_LOAD_DYNAMIC_SUB_MENU_COMPLETE,
    payload: {
      id: id,
      items: items
    }
  };
};

var menuMainLoadDynamicSubMenu = function menuMainLoadDynamicSubMenu(id, url) {
  var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (dispatch, getState, _ref) {
    var networkService = _ref.networkService;
    return networkService.get(url, {
      params: query
    }).then(function (response) {
      dispatch(menuMainLoadDynamicSubMenuComplete(id, response.data.items));
    })["catch"](function (error) {
      if (error instanceof ApiError && error.status === 404) {
        return;
      }

      throw error;
    });
  };
};

var menuMainLoadSubMenuComplete = function menuMainLoadSubMenuComplete(id, items) {
  return {
    type: MENU_MAIN_LOAD_SUB_MENU_COMPLETE,
    payload: {
      id: id,
      items: items
    }
  };
};

var menuMainLoadSubMenu = function menuMainLoadSubMenu(id, url) {
  var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (dispatch, getState, _ref2) {
    var networkService = _ref2.networkService;
    return networkService.get(url, {
      params: query
    }).then(function (response) {
      dispatch(menuMainLoadSubMenuComplete(id, response.data.items));
    })["catch"](function (error) {
      if (error instanceof ApiError && error.status === 404) {
        return;
      }

      throw error;
    });
  };
};

var menuMainLoadProjects = function menuMainLoadProjects() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var query = id ? {
    id: id
  } : null;
  return menuMainLoadDynamicSubMenu(MenuId.myProjects, MENU_MAIN_LOAD_PROJECTS_URL, query);
};

var menuMainLoadChannels = function menuMainLoadChannels() {
  return menuMainLoadSubMenu(MenuId.myChannels, MENU_MAIN_LOAD_CHANNELS_URL);
};

export { menuMainLoadProjects, menuMainLoadChannels };